/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamSearchInputRendererQueryVariables = {
    orgRelayId: string;
    query: string;
};
export type TeamSearchInputRendererQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly " $fragmentRefs": FragmentRefs<"TeamSearchInput_org">;
                    } | null;
                } | null> | null;
            };
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"TeamSearchInput_viewer">;
    };
};
export type TeamSearchInputRendererQuery = {
    readonly response: TeamSearchInputRendererQueryResponse;
    readonly variables: TeamSearchInputRendererQueryVariables;
};



/*
query TeamSearchInputRendererQuery(
  $orgRelayId: ID!
  $query: String!
) {
  viewer {
    ...TeamSearchInput_viewer_OY0Na
    user {
      orgs(first: 1000000) {
        edges {
          node {
            ...TeamSearchInput_org
            id
          }
        }
      }
      id
    }
    id
  }
}

fragment TeamSearchInput_org on Org {
  id
}

fragment TeamSearchInput_viewer_OY0Na on Viewer {
  teamQueryResultErrorable(query: $query, orgRelayId: $orgRelayId) {
    __typename
    ... on TeamQueryResult {
      query
      teams {
        teamName
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        } as any
    ], v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v2 = [
        {
            "kind": "Variable",
            "name": "orgRelayId",
            "variableName": "orgRelayId"
        } as any,
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "TeamSearchInputRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamSearchInput_org"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "args": (v2 /*: any*/),
                            "kind": "FragmentSpread",
                            "name": "TeamSearchInput_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "TeamSearchInputRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": (v2 /*: any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "teamQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "__typename",
                                    "storageKey": null
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "query",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Team",
                                            "kind": "LinkedField",
                                            "name": "teams",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "teamName",
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "TeamQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v3 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "2ed85b35295961cda29973fc0f408adc",
            "id": null,
            "metadata": {},
            "name": "TeamSearchInputRendererQuery",
            "operationKind": "query",
            "text": "query TeamSearchInputRendererQuery(\n  $orgRelayId: ID!\n  $query: String!\n) {\n  viewer {\n    ...TeamSearchInput_viewer_OY0Na\n    user {\n      orgs(first: 1000000) {\n        edges {\n          node {\n            ...TeamSearchInput_org\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment TeamSearchInput_org on Org {\n  id\n}\n\nfragment TeamSearchInput_viewer_OY0Na on Viewer {\n  teamQueryResultErrorable(query: $query, orgRelayId: $orgRelayId) {\n    __typename\n    ... on TeamQueryResult {\n      query\n      teams {\n        teamName\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '12c6a7cf0731c2fe2b18807c0b38bd53';
export default node;
